import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import styles from './Books.module.scss';
import './static.css';
import { useNavigate } from 'react-router-dom';
import quizApi from '~/api/quizApi';
import { toast } from 'react-toastify';
import { BarLoader } from 'react-spinners';
import { Select2 } from '~/components';
import viFlag from '~/assets/icons/vi.svg';
import koFlag from '~/assets/icons/ko.svg';
import enFlag from '~/assets/icons/en.svg';
import { useTranslation } from 'react-i18next';

const optionsLanguage = [
    {
        name: 'Tiếng Việt',
        code: 'vi',
        icon: <img alt="Tiếng Việt" src={viFlag} />,
    },
    {
        name: 'English',
        code: 'en',
        icon: <img alt="English" src={enFlag} />,
    },
    {
        name: '한국인',
        code: 'ko',
        icon: <img alt="한국인" src={koFlag} />,
    },
];

const getIndex = (code) => {
    return optionsLanguage.findIndex((item) => item.code === code);
};

function Books() {
    const { t, i18n } = useTranslation();
    const [first, setFirst] = useState(true);
    const [books, setBooks] = useState([]);
    const navigate = useNavigate();
    function handleOnClickEnterLesson(e, book) {
        navigate(`/book?id=${book.id}`);
    }

    const onChangeOptions = (index, name) => {
        i18n.changeLanguage(optionsLanguage[index].code);
    };

    // load dữ liệu
    useEffect(() => {
        navigate(`/book?id=600bca`);
        // quizApi
        //     .searchBooks({
        //         searchText: '',
        //     })
        //     .then((res) => {
        //         setFirst(false);
        //         console.log('res');
        //         if (res && res.data.code === '00') {
        //             // toast.success('Load dữ liệu thành công');
        //             setBooks(res.data.data);
        //         } else {
        //             toast.error(JSON.stringify(res.data));
        //         }
        //     })
        //     .catch((error) => {
        //         console.log(error);
        //         setFirst(false);
        //     });
    }, []);

    return first ? (
        <div id="loading">
            <BarLoader color="green" />
        </div>
    ) : books.length <= 0 ? (
        <div>No Data</div>
    ) : (
        <main className={styles.wrapper}>
            <div className={styles.content}>
                <div className={styles.header}>
                    <div>{t('books_page_title')}</div>
                    <div className={styles.changeLanguage}>
                        <Select2
                            options={optionsLanguage}
                            intiSelectedIndex={getIndex(i18n.language)}
                            onChange={onChangeOptions}
                            markdown
                            name="language"
                        // ref={refType}
                        ></Select2>
                    </div>
                </div>
                <div className={clsx(styles.scrollable)}>
                    {books.map((book, index) => {
                        return (
                            <div key={`lesson_${book.id}`}>
                                <div className={styles.lesson}>
                                    <div
                                        onClick={(e) =>
                                            handleOnClickEnterLesson(e, book)
                                        }
                                        className={clsx(styles.tittle)}
                                    >
                                        {index + 1 + '. ' + book.name}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className={styles.action}>
                    <div>{t('welcome')}</div>
                </div>
            </div>
        </main>
    );
}

export default Books;
